export const PINNED_LAYER_SUFFIX: string = '-pinned-layer'
export const RESPONSIVE_PAGE_CONTAINER_PREFIX: string = 'Container'
export const SECTIONS_CONTAINER_PREFIX: string = 'PAGE_SECTIONS'
